import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IncubatorApprovalRoutingModule } from './incubator-approval-routing.module';
import { ApprovalListComponent } from './components/approval-list/approval-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { RejectReasonComponent } from './components/reject-reason/reject-reason.component';
import { DescriptionDetailsComponent } from './components/description-details/description-details.component';
import { IncubatorApprovalComponent } from './components/incubator-approval/incubator-approval.component';
import { CorporateApprovalComponent } from './components/corporate-approval/corporate-approval.component';


@NgModule({
  declarations: [ApprovalListComponent, RejectReasonComponent, DescriptionDetailsComponent, IncubatorApprovalComponent, CorporateApprovalComponent],
  imports: [
    CommonModule,
    IncubatorApprovalRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ],
  entryComponents: [RejectReasonComponent,DescriptionDetailsComponent]
})
export class IncubatorApprovalModule { }
